export const getListings = () => {
  return new Promise((resolve, reject) => {
    window.axios
      .get('/api/listings', {
        timeout: 3000,
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
          'X-Requested-With': 'XMLHttpRequest',
          'X-CSRF-TOKEN': document
            .querySelector('meta[name="csrf-token"]')
            .getAttribute('content'),
        },
      })
      .then((response) => resolve(response.data))
      .catch(() => reject('We are having trouble getting the listings.'));
  });
};

export const getListing = (slug) => {
  return new Promise((resolve, reject) => {
    window.axios
      .get(`/api/listings/${slug}`, {
        timeout: 3000,
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
          'X-Requested-With': 'XMLHttpRequest',
          'X-CSRF-TOKEN': document
            .querySelector('meta[name="csrf-token"]')
            .getAttribute('content'),
        },
      })
      .then((response) => resolve(response.data))
      .catch(() => reject('We are having trouble getting the listing.'));
  });
};

export const getNewListings = () => {
  return new Promise((resolve, reject) => {
    window.axios
      .get('/api/listings/new', {
        timeout: 3000,
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
          'X-Requested-With': 'XMLHttpRequest',
          'X-CSRF-TOKEN': document
            .querySelector('meta[name="csrf-token"]')
            .getAttribute('content'),
        },
      })
      .then((response) => resolve(response.data))
      .catch(() => reject('We are having trouble getting the listings.'));
  });
};

export const getSoldListings = () => {
  return new Promise((resolve, reject) => {
    window.axios
      .get('/api/listings/sold', {
        timeout: 3000,
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
          'X-Requested-With': 'XMLHttpRequest',
          'X-CSRF-TOKEN': document
            .querySelector('meta[name="csrf-token"]')
            .getAttribute('content'),
        },
      })
      .then((response) => resolve(response.data))
      .catch(() => reject('We are having trouble getting the listings.'));
  });
};
